import { createI18n } from 'vue-i18n'
import { supportedLocales, type LocaleCode } from './supportedLocales.ts'
import ruRU from './locales/ru-RU.json'
import kzKZ from './locales/kz-KZ.json'
import enUS from './locales/en-US.json'

const storageKey = 'language'
// Фолбэк ПЕРЕВОДОВ (пропущенный ключ словаря) — русский; фолбэк ОПРЕДЕЛЕНИЯ языка
// (язык браузера не из доступных) — английский, правило всего проекта.
const fallbackLocale: LocaleCode = 'ru-RU'
const detectionFallback: LocaleCode = 'en-US'

function isSupported(code: string | null): code is LocaleCode {
  return code != null && supportedLocales.some((locale) => locale.code === code)
}

// Приоритет: явный выбор пользователя (localStorage) → язык браузера → en-US.
function detectLocale(): LocaleCode {
  const stored = localStorage.getItem(storageKey)
  if (isSupported(stored)) return stored

  const navigatorLanguage = navigator.language
  if (isSupported(navigatorLanguage)) return navigatorLanguage

  // kk — ISO-код казахского, локаль в проекте исторически называется kz-KZ.
  const prefix = navigatorLanguage.split('-')[0].toLowerCase()
  if (prefix === 'kk' || prefix === 'kz') return 'kz-KZ'

  const matched = supportedLocales.find((locale) =>
    locale.code.toLowerCase().startsWith(`${prefix}-`),
  )
  return matched?.code ?? detectionFallback
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale,
  messages: {
    'ru-RU': ruRU,
    'kz-KZ': kzKZ,
    'en-US': enUS,
  },
})

// httpClient шлёт выбранный язык бэку (X-Language) — справочники приходят локализованными.
export function getCurrentLanguage(): string {
  return i18n.global.locale.value
}

export function setLanguage(code: LocaleCode): void {
  i18n.global.locale.value = code
  localStorage.setItem(storageKey, code)
  document.documentElement.setAttribute('lang', code)
}

export default i18n
